'use client'

import { useState } from 'react'
import { Link2, Check } from 'lucide-react'

export default function CopyLinkButton() {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy link:', err)
    }
  }

  return (
    <button 
      onClick={handleCopy}
      title="Copy article link"
      className="w-10 h-10 rounded-full border border-border bg-background hover:bg-brand/10 transition-all flex items-center justify-center group relative overflow-hidden"
    >
      <div className={`transition-transform duration-300 ${copied ? '-translate-y-10' : 'translate-y-0'}`}>
        <Link2 className="w-4 h-4 text-muted-foreground group-hover:text-brand" />
      </div>
      <div className={`absolute transition-transform duration-300 ${copied ? 'translate-y-0' : 'translate-y-10'}`}>
        <Check className="w-4 h-4 text-green-500" />
      </div>
    </button>
  )
}
